'use client';

import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';

const ContactTeamSection = () => {
  const contactMethods = [
    {
      icon: 'EnvelopeIcon',
      title: 'Email',
      value: 'drnupur.m@gencarbonesg.in',
      link: 'mailto:drnupur.m@gencarbonesg.in',
      description: 'For detailed inquiries and proposals',
    },
    {
      icon: 'DevicePhoneMobileIcon',
      title: 'WhatsApp',
      value: '+91-9901503669',
      link: 'https://wa.me/919901503669',
      description: 'Quick consultations and support',
    },
    {
      icon: 'VideoCameraIcon',
      title: 'Google Meet',
      value: 'nupurbanker',
      link: 'https://meet.google.com/nupurbanker',
      description: 'Schedule virtual meetings',
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-primary/5 via-background to-secondary/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-heading font-bold text-text-primary mb-4">
              Connect with Our Team
            </h2>
            <p className="text-lg text-text-secondary">
              Our leadership team is available for consultations, partnerships, and 
              strategic sustainability discussions. Reach out through your preferred channel.
            </p>
          </div>

          {/* Contact Cards */}
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            {contactMethods?.map((method, index) => (
              <a
                key={index}
                href={method?.link}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-card border border-border rounded-xl p-6 hover:shadow-natural-lg transition-all duration-300 ease-organic group text-center"
              >
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-primary group-hover:scale-110 transition-all duration-300">
                  <Icon name={method?.icon} size={28} className="text-primary group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-heading font-bold text-text-primary mb-2 group-hover:text-primary transition-colors">
                  {method?.title}
                </h3>
                <p className="text-sm font-semibold text-primary mb-2">{method?.value}</p>
                <p className="text-xs text-text-secondary">{method?.description}</p>
              </a>
            ))}
          </div>

          {/* Professional Network */}
          <div className="bg-card border border-border rounded-xl p-8 text-center">
            <h3 className="text-xl font-heading font-bold text-text-primary mb-4">
              Professional Network
            </h3>
            <p className="text-text-secondary mb-6">
              Connect with Dr. Nupur on LinkedIn to stay updated on industry insights, 
              thought leadership, and GenCarbon's latest sustainability innovations.
            </p>
            <a
              href="https://www.linkedin.com/in/nupurmy/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 px-6 py-3 bg-primary text-primary-foreground font-semibold rounded-lg hover:bg-primary/90 transition-all duration-300"
            >
              <Icon name="GlobeAltIcon" size={20} />
              <span>Connect on LinkedIn</span>
            </a>
          </div>

          {/* Let's Collaborate CTA */}
          <div className="mt-8 text-center">
            <Link
              href="/let-s-collaborate"
              className="inline-flex items-center space-x-2 px-8 py-4 bg-secondary text-secondary-foreground font-bold text-lg rounded-lg hover:bg-secondary/90 hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              <Icon name="UserGroupIcon" size={24} />
              <span>Let's Collaborate</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactTeamSection;